import { type FC } from "react";
import styled, { css } from "styled-components";
import "@nectary/components/title";
import { useSidebarState } from "./state";

const SectionWrapper = styled.div<{ isCollapsed: boolean }>`
  ${({ isCollapsed }) =>
    isCollapsed
      ? css`
          padding: 10px 0 10px 26px;
        `
      : css`
          padding: 0 0 0 34px;
        `};
`;

type SubMenuSectionTitleProps = {
  text: string;
};
export const SubMenuSectionTitle: FC<SubMenuSectionTitleProps> = ({ text }) => {
  const state = useSidebarState();
  return (
    <SectionWrapper isCollapsed={state.isCollapsed}>
      <sinch-title type="s" level="4" text={text} />
    </SectionWrapper>
  );
};
